<div class="chart-wrapper" style="width: 100%;">
<apx-chart
  *ngIf="hasData"
  [chart]="chartOptions.chart"
  [dataLabels]="chartOptions.dataLabels"
  [fill]="chartOptions.fill"
  [legend]="chartOptions.legend"
  [series]="chartOptions.series"
  [stroke]="chartOptions.stroke"
  [tooltip]="chartOptions.tooltip"
  [xaxis]="chartOptions.xaxis"
  [yaxis]="chartOptions.yaxis"
></apx-chart>
</div>
